import { render, staticRenderFns } from "./MatchTip.vue?vue&type=template&id=fb8d1ef8&scoped=true&"
import script from "./MatchTip.vue?vue&type=script&lang=js&"
export * from "./MatchTip.vue?vue&type=script&lang=js&"
import style0 from "./MatchTip.vue?vue&type=style&index=0&id=fb8d1ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8d1ef8",
  null
  
)

export default component.exports